import AdminClubHome from '../../../scenes/admin/AdminClubHome/AdminClubHome';
import AddPlayersToClub from '../../../scenes/admin/ClubWizard/AddPlayersToClub/AddPlayersToClub';
import CreateFirstClubEvent from '../../../scenes/admin/ClubWizard/CreateFirstClubEvent';
import EventWizard from '../../../scenes/admin/EventWizard';
import AssignRoundAwards from '../../../scenes/admin/EventWizard/AssignRoundAwards/AssignRoundAwards';
import CompleteEvents from '../../../scenes/admin/EventWizard/CompleteEvent/CompleteEvent';
import { CompleteRound } from '../../../scenes/admin/EventWizard/CompleteRound/CompleteRound';
import { EventBasics } from '../../../scenes/admin/EventWizard/EventBasics/Components/EventBasics';
// import EventFees from '../scenes/admin/EventWizard/EventFees/EventFees';
import { EventFormats } from '../../../scenes/admin/EventWizard/EventFormats/EventFormats';
import EventFlights from '../../../scenes/admin/EventWizard/EventFlights/EventFlights';
import { InvitePlayers } from '../../../scenes/admin/EventWizard/InvitePlayers/InvitePlayers';
import EventPublish from '../../../scenes/admin/EventWizard/EventPublish/EventPublish';
import EventResults from '../../../scenes/admin/EventWizard/EventResults/EventResults';
import { EventRounds } from '../../../scenes/admin/EventWizard/EventRounds/EventRounds';
import EventSetup from '../../../scenes/admin/EventWizard/EventSetup/EventSetup';
import EventStart from '../../../scenes/admin/EventWizard/EventStart/EventStart';
import LaunchRound from '../../../scenes/admin/EventWizard/LaunchRound/LaunchRound';
import RoundBasics from '../../../scenes/admin/EventWizard/RoundBasics';
import { RoundFlights } from '../../../scenes/admin/EventWizard/RoundFlights/RoundFlights';
import { RoundSetup } from '../../../scenes/admin/EventWizard/RoundSetup/RoundSetup';
import { TeamsCreator } from '../../../scenes/admin/EventWizard/TeamsCreator/TeamsCreator';
import TeeSheetCreator from '../../../scenes/admin/EventWizard/TeeSheetCreator';
import { Ledger } from '../../../scenes/admin/Ledger/Ledger';
import ListEvents from '../../../scenes/admin/ListEvents/ListEvents';
import { Pages } from '../../../scenes/admin/Pages/Pages';
import PlayerInfo from '../../../scenes/admin/PlayerInfo/PlayerInfo';
import ClubSettings from '../../../scenes/admin/Settings/ClubSettings/ClubSettings';
import PlayersRoster from '../../../scenes/admin/Settings/PlayersRoster/PlayersRoster';
import { StaffHome } from '../../../scenes/admin/StaffHome/StaffHome';
import StaffStart from '../../../scenes/admin/StaffStart';
// import Standings from '../scenes/admin/Standings/Standings';
import Login from '../../../scenes/common/Login';
import { RequestNewPassword } from '../../../scenes/common/RequestNewPassword/RequestNewPassword';
import AccountSettings from '../../../scenes/player/AccountSettings';
import EditPicture from '../../../scenes/player/AccountSettings/EditPicture';
import SelectPicture from '../../../scenes/player/AccountSettings/SelectPicture';
import TakePicture from '../../../scenes/player/AccountSettings/TakePicture';

import { IRoute } from '../IRoute';
import ContestSetup from '../../../scenes/admin/EventWizard/ContestSetup/ContestSetup';

const EVENT_WIZARD_ACTIONS = [
  'adminClubCreditCard',
  'adminClubs',
  'adminCourses',
  'adminEventAwards',
  'adminEventEnrollments',
  'adminEventRounds',
  'adminEvents',
  'adminFees',
  'adminGroups',
  'adminInvitations',
  'adminMemberships',
  'adminRoundAwards',
  'adminRoundFormats',
  'adminRoundPayments',
  'roundScores',
  'clubs',
  'roundTees',
  'user'
];

const AdminRoutes: IRoute[] = [
  {
    actions: ['adminClubs'],
    component: StaffStart,
    key: '/staff',
    path: '/staff',
    scope: 'staff'
  },
  {
    actions: ['adminClubs'],
    component: StaffHome,
    key: '/staff/home',
    path: '/staff/home',
    scope: 'staff'
  },
  {
    actions: ['adminClubs', 'adminEvents'],
    component: Pages,
    key: '/staff/club/:clubId/pages/:slug',
    path: '/staff/club/:clubId/pages/:slug',
    scope: 'staff'
  },
  {
    actions: EVENT_WIZARD_ACTIONS,
    component: EventWizard,
    key: '/staff/club/:clubId/event',
    path: '/staff/club/:clubId/event'
  },
  {
    actions: EVENT_WIZARD_ACTIONS,
    children: [
      {
        actions: EVENT_WIZARD_ACTIONS,
        children: [
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventStart,
            key: 'event-wizard-setup-start',
            path: 'start'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventBasics,
            key: 'event-wizard-setup-basic',
            path: 'basic'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventRounds,
            key: 'event-wizard-setup-rounds',
            path: 'rounds'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventFormats,
            key: 'event-wizard-setup-formats',
            path: 'formats'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventFlights,
            key: 'event-wizard-setup-flights',
            path: 'flights'
          },
          // Temporarily disable fees screen due to https://code.talpor.com/club15/frontend/-/issues/900
          // {
          //   actions: EVENT_WIZARD_ACTIONS,
          //   component: EventFees,
          //   key: 'event-wizard-setup-fees',
          //   path: 'fees'
          // },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: EventPublish,
            key: 'event-wizard-setup-publish',
            path: 'publish'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: InvitePlayers,
            key: 'event-wizard-setup-players',
            path: 'players'
          }
        ],
        component: EventSetup,
        key: 'event-wizard-setup',
        path: 'setup'
      },
      {
        actions: EVENT_WIZARD_ACTIONS,
        children: [
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: RoundBasics,
            key: 'event-wizard-round-basic',
            path: 'setup'
          },
          {
            component: ContestSetup,
            key: 'event-wizard-round-contest-selector',
            path: 'contest'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: RoundFlights,
            key: 'event-wizard-round-flights',
            path: 'flights'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: TeeSheetCreator,
            key: 'event-wizard-round-tee-sheet',
            path: 'teesheet'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: TeamsCreator,
            key: 'event-wizard-round-teams',
            path: 'teams'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: LaunchRound,
            key: 'event-wizard-round-launch',
            path: 'launch'
          },
          {
            actions: [...EVENT_WIZARD_ACTIONS, 'games'],
            component: EventResults,
            key: 'event-wizard-round-results',
            path: 'results'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: AssignRoundAwards,
            key: 'event-wizard-round-awards',
            path: 'awards'
          },
          {
            actions: EVENT_WIZARD_ACTIONS,
            component: CompleteRound,
            key: 'event-wizard-round-complete',
            path: 'complete'
          }
        ],
        component: RoundSetup,
        key: 'round-setup',
        path: 'round/:roundId'
      },
      {
        actions: EVENT_WIZARD_ACTIONS,
        component: CompleteEvents,
        key: 'complete-event',
        path: 'complete'
      }
    ],
    component: EventWizard,
    key: 'event-wizard',
    path: '/staff/club/:clubId/event/:eventId'
  },
  {
    actions: ['adminClubs', 'clubs'],
    component: Ledger,
    key: '/staff/club/:clubId/ledger',
    path: '/staff/club/:clubId/ledger'
  },
  {
    actions: ['adminEvents', 'adminClubs', 'adminInvitations', 'adminMemberships'],
    component: AdminClubHome,
    key: '/staff/club/:clubId',
    path: '/staff/club/:clubId'
  },
  {
    actions: ['adminEvents', 'adminClubs', 'seasons'],
    component: ListEvents,
    key: '/staff/club/:clubId/events',
    path: '/staff/club/:clubId/events'
  },
  {
    actions: ['user', 'adminInvitations'],
    component: AddPlayersToClub,
    key: '/staff/club/complete/:clubID/add-players',
    path: '/staff/club/complete/:clubID/add-players'
  },
  {
    actions: ['user', 'adminEvents'],
    component: CreateFirstClubEvent,
    key: '/staff/club/complete/:clubID/first-event',
    path: '/staff/club/complete/:clubID/first-event'
  },
  {
    actions: [
      'adminClubCreditCard',
      'adminClubs',
      'adminCourses',
      'adminEvents',
      'adminMemberships',
      'pages',
      'seasons',
      'user',
      'avatar'
    ],
    component: ClubSettings,
    key: '/staff/club/:clubId/club-settings',
    path: '/staff/club/:clubId/club-settings'
  },
  {
    actions: ['user', 'adminMemberships', 'adminEvents', 'adminPlayerEnrollments'],
    component: PlayerInfo,
    key: '/staff/club/:clubId/player-info/:userId',
    path: '/staff/club/:clubId/player-info/:userId'
  },
  {
    actions: [
      'user',
      'errors',
      'adminClubs',
      'adminMemberships',
      'adminInvitations',
      'adminGroups'
    ],
    component: PlayersRoster,
    key: '/staff/club/:clubId/players-roster',
    path: '/staff/club/:clubId/players-roster'
  },
  // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
  // {
  //   actions: ['adminClubs', 'adminEvents', 'seasons', 'adminSeasonAwards'],
  //   component: Standings,
  //   key: '/staff/club/:clubId/standings',
  //   path: '/staff/club/:clubId/standings',
  //   scope: 'staff'
  // },
  {
    actions: ['clubs', 'user', 'memberships'],
    component: AccountSettings,
    key: '/staff/profile/settings',
    path: '/staff/profile/settings'
  },
  {
    actions: ['avatar', 'user'],
    component: EditPicture,
    key: '/staff/profile/edit-picture',
    path: '/staff/profile/edit-picture'
  },
  {
    actions: ['avatar', 'user'],
    component: SelectPicture,
    key: '/staff/profile/select-picture',
    path: '/staff/profile/select-picture'
  },
  {
    actions: ['avatar', 'user'],
    component: TakePicture,
    key: '/staff/profile/take-picture',
    path: '/staff/profile/take-picture'
  },
  {
    actions: ['invitation', 'adminClubs'],
    component: Login,
    key: '/staff/login',
    path: '/staff/login',
    scope: 'staff'
  },
  {
    actions: ['invitation'],
    component: RequestNewPassword,
    key: '/staff/requestResetPassword',
    path: '/staff/requestResetPassword',
    scope: 'guest'
  }
];

export default AdminRoutes;
